<cerrix-dialog [name]="name" data-uiid="risk-dialog-generate-ai-risk">
    <span header-title> Generate risks with AI </span>
    <div class="generate-risks-content" dialog-content>
        <span class="generate-risks-description"
            >Upload a document to extract risks and controls with AI</span
        >
        @if (creaiDocument) {
            <div class="documents-container">
                <div class="documents-title">Files</div>
                <div class="document-list">
                    <div class="document">
                        <mat-icon class="document-icon" [svgIcon]="'document'"></mat-icon>
                        <div class="document-name">{{ creaiDocument.Name }}</div>
                        <mat-icon
                            class="delete-icon"
                            [svgIcon]="'delete'"
                            (click)="creaiDocument = null"
                            data-uiid="risk-dialog-generate-ai-risk--delete-document"
                        ></mat-icon>
                    </div>
                </div>
            </div>
        } @else {
            <cerrix-drop-area
                [allowedFileExtensions]="creaiAllowedExtensions"
                [multiple]="false"
                (onFileSelection)="onFileSelection($event)"
                data-uiid="risk-dialog-generate-ai-risk--drop-area"
            ></cerrix-drop-area>
        }
    </div>
    <div class="generate-risks-footer" dialog-footer>
        @if(showGoBack){
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="goBack()"
            data-uiid="risk-dialog-generate-ai-risk--go-back"
            >Go back</cerrix-button
        >
        }
        <cerrix-button
            buttonSize="big"
            [disabled]="!creaiDocument"
            [waitingOnResult]="creaiGeneratingRisks"
            (click)="generateAiRisks()"
            data-uiid="risk-dialog-generate-ai-risk--generate"
            >Generate risks & controls</cerrix-button
        >
    </div>
</cerrix-dialog>